{{#if isProductPage}}
    <div class="messageBox messageBox_tight messageBox_alert" style="margin-bottom: 20px;">
        <p class="bdcpy bdcpy_md" style="margin: 0 0 10px;">
            <span class="lbl lbl_bold">Note: </span>Shipping estimates are calculated based on the current product configuration, including the cost of shipping this item and any other items in your shopping cart.
        </p>
        <p class="bdcpy bdcpy_md" style="margin: 0;">
            Freight shipping charges may apply to some orders, depending on their size and weight. For questions, please initiate an online chat or call our customer service at 888-934-6909.
        </p>
    </div>
{{else}}
    <p class="bdcpy" style="margin-top: 0;">Get shipping estimates for your current cart contents. You can modify the shipping service during checkout.</p>
{{/if}}

<form class="spdcForm{{#if loading}} requestIsProcessing{{/if}}" action="">
    {{#with estimate}}
        {{!-- ADDRESS BOOK (logged in with saved addresses) --}}
        {{#if @root.addresses.length}}
            {{#unless @root.showManualEntry}}
                <div class="spdcForm-row">
                    <label class="spdcForm-lbl">Ship To</label>
                    <select class="spdcForm-select js-element--address">
                        {{#each @root.addresses}}
                            <option value="{{id}}" {{#ifEquals id @root.selectedAddressId}}selected{{/ifEquals}}>
                                {{storefrontListItemName}}
                            </option>
                        {{/each}}
                        <option value="new">+ Add a new address</option>
                    </select>
                </div>
            {{else}}
                <div class="spdcForm-row">
                    <a href="#" class="link js-action--use-saved-address">← Use a saved address</a>
                </div>
            {{/unless}}
            {{!-- MANUAL ENTRY (not logged in, no addresses, or "Add new" selected) --}}
            {{#if @root.showManualEntry}}
                {{> shippingAddressForm}}
            {{/if}}
        {{else}}
            {{#if @root.loggedIn}}
                {{> shippingAddressForm}}
            {{else}}
                {{!-- NO ADDRESSES (not logged in: show simple country/state/zip form --}}
                <div class="spdcForm-row spdcForm-row_2up">
                    <div>
                        <label class="spdcForm-lbl">Ship to Country</label>
                        <select class="spdcForm-select js-element--country">
                            {{#if country}}
                                <option value="{{country.id}}" selected="true">{{country.name}}</option>
                            {{/if}}
                            {{#each countries}}
                                <option value="{{id}}">{{name}}</option>
                            {{/each}}
                        </select>
                    </div>
                    <div>
                        {{#if country.hasRegions}}
                            <label class="spdcForm-lbl">Ship to Region / State</label>
                            <select class="spdcForm-select js-element--state">
                                {{#if state}}
                                    <option value="{{state.id}}" selected="true">{{state.name}}</option>
                                {{else}}
                                    <option value="">Select One</option>
                                {{/if}}
                                {{#each states}}
                                    <option value="{{id}}">{{name}}</option>
                                {{/each}}
                            </select>
                        {{/if}}
                    </div>
                </div>
                <div class="spdcForm-row spdcForm-row_2up">
                    <div class="spdcForm-row-item">
                        {{#if country.hasPostalCodes}}
                            <label class="spdcForm-lbl">Ship to Postal / Zip Code</label>
                            <input class="spdcForm-input js-element--zip" value="{{postalCode}}" type="text" />
                        {{/if}}
                    </div>
                    <div class="spdcForm-row-item">
                        <input class="spdcForm-btn js-action--get-quote" type="submit" value="Get Shipping Estimate">
                    </div>
                </div>
            {{/if}}
        {{/if}}
    {{/with}}
</form>
<div class="globalDialog-ft globalDialog-ft_fill {{#if loading}}isDelayed{{/if}}">
    <form class="spdcForm" action="">
        <fieldset>
            {{#if estimate.quotes.length}}
                <table class="keyValTable keyValTable_80-20">
                    <tbody>
                        {{#each estimate.quotes}}
                            {{#if (contains @root.activeServices internalId.shippingServiceId)}}
                                <tr>
                                    <td>
                                        {{#if @root.canSelectServices}}
                                            <input class="spdcForm-radio js-element--quote" name="shippingOptions" type="radio" id="{{id}}" {{#ifEquals id @root.selectedServiceId}}checked{{/ifEquals}} />
                                        {{/if}}
                                        <label class="spdcForm-lbl" for="{{id}}">{{description}}</label>
                                    </td>
                                    <td class="lbl lbl_lg" style="text-align: right;">${{displayPrice}}</td>
                                </tr>
                            {{/if}}
                        {{/each}}
                    </tbody>
                </table>
            {{/if}}
        </fieldset>
    </form>
</div>
